import { render } from "./ChildTrackingSystem.vue?vue&type=template&id=237332aa&scoped=true"
import script from "./ChildTrackingSystem.vue?vue&type=script&lang=js"
export * from "./ChildTrackingSystem.vue?vue&type=script&lang=js"

import "./ChildTrackingSystem.vue?vue&type=style&index=0&id=237332aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237332aa"]])

export default __exports__